import { render, staticRenderFns } from "./CreateEmailTemplateDialog.vue?vue&type=template&id=165b0e1c&lang=pug&"
import script from "./CreateEmailTemplateDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateEmailTemplateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports